import { render } from "./BuyAVehicle.vue?vue&type=template&id=4c2290fb&lang=true"
import script from "./BuyAVehicle.vue?vue&type=script&lang=js"
export * from "./BuyAVehicle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/AssistantAi/StartUpIcons/BuyAVehicle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c2290fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c2290fb', __exports__)) {
    api.reload('4c2290fb', __exports__)
  }
  
  module.hot.accept("./BuyAVehicle.vue?vue&type=template&id=4c2290fb&lang=true", () => {
    api.rerender('4c2290fb', render)
  })

}


export default __exports__